import { useContext, ChangeEvent, useEffect } from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useInView } from 'react-intersection-observer'
import { useParams } from 'react-router-dom'

import { SellersContext } from '../../../../../../app/contexts/SellerContex'
import { teamsService } from '../../../../../../app/services/teamsService'
import { useToast } from '../../../../../components/ui/use-toast'
import { UpdateTeamdata } from '../../../../../../app/services/teamsService/updateTeam'

type useAddSupervisorProps = {
  _id: string
  name: string
  profileImageUrl: string
}

export const useAddSupervisorController = () => {
  const { id } = useParams()
  const { ref, inView } = useInView()
  const queryClient = useQueryClient()

  const { sellers, setSearchValue, searchValue } = useContext(SellersContext)

  const { data, fetchNextPage, hasNextPage, isFetching, isFetchingNextPage } =
    sellers
  const { toast } = useToast()

  const handleSearchInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchValue(event.target.value)
  }

  useEffect(() => {
    if (inView) {
      fetchNextPage()
    }
  }, [fetchNextPage, inView])

  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['AddMember'],
    mutationFn: async ({
      teamId,
      memberId,
    }: {
      teamId: string
      memberId: UpdateTeamdata
    }) => await teamsService.updateTeam(memberId, teamId),
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: ['teamId', id],
      })
    },
  })

  const handleUpdateSupervisor = async (user: useAddSupervisorProps) => {
    try {
      if (user) {
        await mutateAsync({
          teamId: id!,
          memberId: { supervisor_id: user._id },
        })

        toast({
          title: 'Supervisor atualizado com sucesso.',
        })
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      console.log(error)
      toast({
        variant: 'destructive',
        title:
          error.message ||
          'Erro ao atualizar o supervisor, tente novamente mais tarde',
      })
    }
  }

  return {
    data,
    isFetching,
    searchValue,
    handleSearchInputChange,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    ref,
    handleUpdateSupervisor,
    isPending,
  }
}
